import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@/redux/hooks';
import { getDeployment } from '@/redux/modules/config';
import { track } from '@/utils/amplitude/analytics/core';
import { AccountDetailsEventFlow, TrackingEvents, TrackingPayload } from '@/utils/amplitude/analytics/core.types';
import { getFullUrl } from '@/utils/amplitude/analytics/utils/getFullUrl';
import { getAmplitudePageNameFromPath } from '@/utils/getPageNameFromPath';

type AddShippingAddressViewedPayload = TrackingPayload & {
    eventFlow: AccountDetailsEventFlow;
};

const trackAddShippingAddressViewed = (payload: AddShippingAddressViewedPayload) => {
    track(TrackingEvents.Account.AddShippingAddressViewed, payload);
};

export const useTrackAddShippingAddressViewed = (eventFlow: AccountDetailsEventFlow) => {
    const deployment = useAppSelector(getDeployment);
    const { pathname } = useLocation();

    return useCallback(() => {
        trackAddShippingAddressViewed({
            eventFlow,
            pageName: getAmplitudePageNameFromPath(pathname),
            url: getFullUrl(deployment, pathname),
        });
    }, [deployment, eventFlow, pathname]);
};
